var React = require('react');

function Arrow2 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M11.082 2.12157L18.7702 9.95995L11.082 17.6543","stroke":"#141B4A","strokeWidth":"2.5","key":0}),React.createElement("path",{"d":"M18.0137 9.8877L0.330842 9.8877","stroke":"#141B4A","strokeWidth":"2.5","key":1})]);
}

Arrow2.defaultProps = {"width":"21","height":"20","viewBox":"0 0 21 20","fill":"none"};

module.exports = Arrow2;

Arrow2.default = Arrow2;
